// Community Management Actions
export const COMMUNITY_ACTION_STARTS = 'COMMUNITY_ACTION_STARTS';
export const COMMUNITY_ACTION_ERRORS = 'COMMUNITY_ACTION_ERRORS';

// Get all communities
export const GET_ALL_COMMUNITIES = 'GET_ALL_COMMUNITIES';
export const GET_COMMUNITY_BY_ID = 'GET_COMMUNITY_BY_ID';
export const GET_MY_COMMUNITIES = 'GET_MY_COMMUNITIES';

// Create, Update, Delete communities
export const CREATE_COMMUNITY = 'CREATE_COMMUNITY';
export const UPDATE_COMMUNITY = 'UPDATE_COMMUNITY';
export const DELETE_COMMUNITY = 'DELETE_COMMUNITY';
export const TRANSFER_OWNERSHIP = 'TRANSFER_OWNERSHIP';
export const JOIN_COMMUNITY = 'JOIN_COMMUNITY';
export const LEAVE_COMMUNITY = 'LEAVE_COMMUNITY';

// Action creators
export const communityActionStarts = () => ({
  type: COMMUNITY_ACTION_STARTS,
});

export const communityActionErrors = (error: string) => ({
  type: COMMUNITY_ACTION_ERRORS,
  payload: error,
});

export const getAllCommunitiesAction = (communities: any[]) => ({
  type: GET_ALL_COMMUNITIES,
  payload: communities,
});

export const getCommunityByIdAction = (community: any) => ({
  type: GET_COMMUNITY_BY_ID,
  payload: community,
});

export const getMyCommunitiesAction = (communities: any[]) => ({
  type: GET_MY_COMMUNITIES,
  payload: communities,
});

export const createCommunityAction = (community: any) => ({
  type: CREATE_COMMUNITY,
  payload: community,
});

export const updateCommunityAction = (community: any) => ({
  type: UPDATE_COMMUNITY,
  payload: community,
});

export const deleteCommunityAction = (communityId: string) => ({
  type: DELETE_COMMUNITY,
  payload: communityId,
});

export const transferOwnershipAction = (communityId: string, newOwnerId: string) => ({
  type: TRANSFER_OWNERSHIP,
  payload: { communityId, newOwnerId },
});

export const joinCommunityAction = (communityId: string) => ({
  type: JOIN_COMMUNITY,
  payload: communityId,
});

export const leaveCommunityAction = (communityId: string) => ({
  type: LEAVE_COMMUNITY,
  payload: communityId,
});
